import gql from 'graphql-tag'

export const sitemapPageQuery = gql`
  query sitemapPageQuery {
    newIndustries(pagination: { pageSize: 50 }, sort: "seo.title") {
      data {
        id
        attributes {
          slug
          seo {
            title
          }
        }
      }
    }
    newServices(
      pagination: { pageSize: 50 }
      sort: "seo.title"
      filters: { exclusiveLpPage: { eq: false } }
    ) {
      data {
        id
        attributes {
          seo {
            title
          }
          slug
          type
        }
      }
    }
    features(pagination: { pageSize: 50 }, sort: "seo.title") {
      data {
        id
        attributes {
          slug
          seo {
            title
          }
        }
      }
    }
    useCases(pagination: { pageSize: 50 }, sort: "seo.title") {
      data {
        id
        attributes {
          slug
          seo {
            title
          }
        }
      }
    }
    categories(pagination: { pageSize: 50 }, sort: "page_title") {
      data {
        id
        attributes {
          servicesTitle
          slug
        }
      }
    }
    resources(pagination: { pageSize: 100 }, sort: "title") {
      data {
        id
        attributes {
          title
          slug
          type
        }
      }
    }
  }
`

export const translationPageSitemapQuery = gql`
  query translationPageSitemapQuery($page: Int!, $limit: Int!) {
    translationPages(
      pagination: { page: $page, pageSize: $limit }
      sort: "page_title"
    ) {
      meta {
        pagination {
          page
          pageSize
          pageCount
          total
        }
      }
      data {
        id
        attributes {
          slug
          page_title
          source_language {
            data {
              attributes {
                iso_code
              }
            }
          }
        }
      }
    }
  }
`
